import React from 'react'
import { getBonusThresholdModalDescription } from '../util'
import { Checkbox } from '../../../../../Components/Form'
import boomSound from '../../../../../Assets/Sounds/vine-boom.mp3'
import { COUNTRY_CODE } from '../../../../../constants'

const BonusChangesModal = ({
  toggleConfirmAvailabilityReduxModal,
  country,
  wasBonusAllowanceChanged,
  bonusLimit,
  wasPayoutPerConversionChanged,
  payoutPerConversion,
  wasBonusThresholdChanged,
  bonusThreshold,
}) => {
  const bonusPerConversionLimit = 50
  const checkPayoutBonus = bonus => {
    if (
      bonus > bonusPerConversionLimit &&
      country.code !== COUNTRY_CODE.MEXICO
    ) {
      new Audio(boomSound).play()
      return (
        <span style={{ color: 'red' }}>{` ${country.currency}${bonus}`}</span>
      )
    } else return ` ${country.currency}${bonus}`
  }

  return (
    <section className="redux-modal">
      <article>
        <p>
          This data (and more) will be set for all NEWLY published missions:
        </p>
        <ul className="redux-modal__list">
          <li>
            Conversion Bonus:
            <ul>
              {wasBonusAllowanceChanged && (
                <li>Bonus Allowance: {`${country.currency}${bonusLimit}`}</li>
              )}
              {wasPayoutPerConversionChanged && (
                <li>
                  Bonus Per Conversion:
                  {checkPayoutBonus(payoutPerConversion)}
                </li>
              )}
              {wasBonusThresholdChanged && (
                <li>
                  Bonus Threshold:{' '}
                  {getBonusThresholdModalDescription(bonusThreshold)}
                </li>
              )}
            </ul>
          </li>
        </ul>
      </article>
      <footer className="redux-modal__footer">
        <Checkbox
          input={{
            onClick: toggleConfirmAvailabilityReduxModal,
          }}
          cypress_id="change-campaign-bonus-checkbox"
        />
        <span className="redux-modal__checkbox-hint">
          I understand changing these values will only affect NEWLY published
          missions.
        </span>
      </footer>
    </section>
  )
}

export default BonusChangesModal
